import { IAppContextActions, IAppContextState } from './types'

export const initialState = {
  signed: false,
  load: true,
  renderModalPasswordReset: false,
  passwordResetRequired: false,
  renderModalUsedTab: false,
  renderModalForgotPassword: false,
} as IAppContextState

export function reducerApp(
  state: IAppContextState,
  action: IAppContextActions,
): IAppContextState {
  switch (action.type) {
    case 'updateApp':
      return functionsReducer[action.type](state, action.data)
    case 'openModalUsedTab':
      return functionsReducer[action.type](state, action.data)
    default:
      return state
  }
}

const functionsReducer = {
  updateApp: (state: IAppContextState, data?: Partial<IAppContextState>) => {
    return { ...state, ...data }
  },
  openModalUsedTab: (
    state: IAppContextState,
    data?: Partial<IAppContextState>,
  ) => {
    return { ...state, ...data }
  },
}
